function routeLocale(url) {
    const locale = document.querySelector('meta[name="locale"]')?.getAttribute('content');
    if (locale == 'pt_BR') {
        return url;
    }

    return url.replace('api/', locale + '/api/');
}

window.routeLocale = routeLocale;

export default routeLocale;
